module.exports = __webpack_public_path__ + "img/Asset_2.4f50dd49.svg";